import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { getMonitoreoMetric } from '../../store/fuse/monitoreo';
import { getDashboardFirstSection, getDashboardDevices, getDashboardProperty } from '../../store/fuse/dashboard';
import { getTotalTickets, getGraphicTickets, getGraphicPerWeekTickets } from '../../store/fuse/nivelService';
import { WrapperLoader } from './styles';

const Index = (props) => {
  const dispatch = useDispatch();
  const initMonitoreoMetric = () => dispatch(getMonitoreoMetric());
  const initTotalTickets = () => dispatch(getTotalTickets());
  const initGraphicTickets = () => dispatch(getGraphicTickets());
  const initGraphicPerWeekTickets = () => dispatch(getGraphicPerWeekTickets());
  const initDashboardFirstSection = () => dispatch(getDashboardFirstSection());
  const initDashboardDevices = () => dispatch(getDashboardDevices());
  const initDashboardProperty = () => dispatch(getDashboardProperty());

  const loaderData = async (fnname) => {
    switch (fnname) {
      case 'metrics':
        initMonitoreoMetric();
        break;
      case 'totalTickets':
        initTotalTickets();
        break;
      case 'graficaTickets':
        initGraphicTickets();
        break;
      case 'graficaTicketsWeek':
        initGraphicPerWeekTickets();
        break;
      case 'firstSection':
        initDashboardFirstSection();
        break;
      case 'graphics':
        initDashboardProperty();
        break;
      case 'devices':
        initDashboardDevices();
        break;
      default:
        break;
    }
  };

  console.log("PROPS->", props);

  return (
    <WrapperLoader>
      <strong>Ups... hubo un problema al cargar la sección.</strong>
      <Button variant="contained" color="primary" style={{ margin: '10px' }} onClick={() => loaderData(props.nameComponent)}>
        {props.loader ? (
          <>
            {' '}
            Cargando... <CircularProgress />{' '}
          </>
        ) : (
          <>Recargar {props.nameLabel}</>
        )}
      </Button>
    </WrapperLoader>
  );
};

export default Index;
